import React, { useEffect } from 'react';
import Input from '@material-ui/core/Input';
import ContainerComponent from './ContainerComponent';
import { SET_VALUE } from '../formReducer';

interface Props {
  value: string;
  formId: string;
  formName: string;
  formDispatch: any;
  autoFocus?: boolean;
  item: {
    label: string;
    name: string;
    placeholder: string;
    subtype?: string;
    required?: boolean;
    type?: string;
    description?: string;
  };
  readOnly: boolean;
  dataTestSc?: string;
}

const DateFieldComponent: React.FC<Props> = ({
  value,
  formDispatch,
  formId,
  formName,
  autoFocus,
  item: { label, name: fieldId, placeholder, required, type, description },
  readOnly,
  dataTestSc,
}) => {
  useEffect(() => {
    // Initialize with today's date like platform-v2 does
    const today = new Date();
    const parseDate =
      today.getFullYear() +
      '-' + ('0' + (today.getMonth() + 1)).slice(-2) +
      '-' + ('0' + today.getDate()).slice(-2);
    formDispatch({ type: SET_VALUE, payload: { value: parseDate, fieldId, formId } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = ({ target: { value } }: any) => {
    formDispatch({ type: SET_VALUE, payload: { value, fieldId, formId } });
    formDispatch({ type: SET_VALUE, payload: { value, fieldId, formId: formName } });
  };

  return (
    <ContainerComponent label={label} required={!!required} description={description}>
      <Input
        style={{ width: '100%', fontFamily: "'Google Sans',Roboto,Arial,sans-serif", fontSize: 14 }}
        placeholder={placeholder}
        value={value}
        type='date'
        onChange={handleChange}
        {...(type === 'textarea' ? { multiline: true as any, rows: 3 as any } : {})}
        autoFocus={autoFocus}
        inputProps={dataTestSc ? { 'data-test-sc': dataTestSc } : undefined}
        disabled={readOnly}
      />
    </ContainerComponent>
  );
};

export default DateFieldComponent;
